import type { Infer } from 'superstruct';
import { nullable, object, record } from 'superstruct';

import { parsableInteger } from '@adflow/shared/util-superstruct';

import { DataTableItemType } from './data-table-item-type';

export const ViewColumnTemplateSettingsDto = object({
	defaultColumnTemplateId: nullable(parsableInteger()),
});

export type ViewColumnTemplateSettingsDto = Infer<
	typeof ViewColumnTemplateSettingsDto
>;

export const ViewFullColumnTemplateSettingsDto = record(
	DataTableItemType,
	ViewColumnTemplateSettingsDto
);

export type ViewFullColumnTemplateSettingsDto = Infer<
	typeof ViewFullColumnTemplateSettingsDto
>;
